import { Box, Typography } from "@mui/material";
import React from "react";

interface VenueWidgetProps {
  title: string;

  children: React.ReactNode;
  sx?: object;
}

const VenueWidgets: React.FC<VenueWidgetProps> = ({ title, children }) => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "#ffffff",
        height: "100%",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h6"
        textAlign="center"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        {title}
      </Typography>

      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  );
};

export default VenueWidgets;
